// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-20455ddf]{width:80%}@media (max-width:767px){[data-v-20455ddf] .objects-last-seen{grid-template-columns:repeat(auto-fit,minmax(11em,.5fr))}}@media (max-width:575px){[data-v-20455ddf] .objects-last-seen{grid-template-columns:repeat(auto-fit,minmax(11em,1.5fr))}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
